import React, { Component } from 'react'
import { Card, MenuItem, FormControl, TextField, InputAdornment, List, ListItem, Link, Divider } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search';
import isEmpty from 'lodash.isempty';


export default class SideSearchbar extends Component {


  constructor(props) {
    super(props);
    this.state = {
      filtered: [],
      filterField: '',
      activeValue: this.props.activeField ? 0 : 2,
      internExternVal: this.props.internExtern ? 0 : 2,
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { listData, newList, editedList, deleteList, activeField } = this.props
    const { filterField, filtered, activeValue } = this.state
    if (nextProps.listData !== listData && isEmpty(filterField)) {
      if (activeField) {
        this.activeList(nextProps.listData)
      } else {
        this.setState({ filtered: nextProps.listData })
      }
    }

    else if (nextProps.newList !== undefined && nextProps.newList !== newList && !isEmpty(filterField)) {
      if (activeField) {
        if ((nextProps.newList.active === false && activeValue === 1) ||
          (nextProps.newList.active === true && activeValue === 0) || activeValue === 2) {
          let name = nextProps.newList.name
          if (name.toLowerCase().includes(filterField)) {
            filtered.push(nextProps.newList)
            this.setState({ filtered })
          }
        }
      } else {
        let name = nextProps.newList.name
        if (name.toLowerCase().includes(filterField)) {
          filtered.push(nextProps.newList)
          this.setState({ filtered })
        }
      }
    } else if (nextProps.editedList !== undefined && nextProps.editedList !== editedList && !isEmpty(filterField)) {
      if (activeField) {
        if (nextProps.editedList !== '') {
          if ((nextProps.editedList.active === false && activeValue === 1) ||
            (nextProps.editedList.active === true && activeValue === 0) || activeValue === 2) {
            let name = nextProps.editedList.name
            if (name.toLowerCase().includes(filterField)) {
              let resulted = filtered.map((item, index) => {
                if (item.id === nextProps.editedList.id) {
                  item = nextProps.editedList
                }
                return item
              })
              this.setState({ filtered: resulted })
            }
          } else {
            let indexOf = ''
            let resulted = filtered.map((item, index) => {
              if (item.id === nextProps.editedList.id) {
                indexOf = index
              }
              return item
            })
            resulted.splice(indexOf, 1)
            this.setState({ filtered: resulted })
          }
        }
      } else {
        let name = nextProps.editedList.name
        if (name.toLowerCase().includes(filterField)) {
          let resulted = filtered.map(item => {
            if (item.id === nextProps.editedList.id) {
              item = nextProps.editedList
            }
            return item
          })
          this.setState({ filtered: resulted })
        } else {
          let indexOf = ''
          let resulted = filtered.map((item, index) => {
            if (item.id === nextProps.editedList.id) {
              indexOf = index
            }
            return item
          })
          resulted.splice(indexOf, 1)
          this.setState({ filtered: resulted })
        }
      }
    } else if (nextProps.deleteList !== deleteList) {
      let indexOf = ''
      let resulted = filtered.map((item, index) => {
        if (item.id === nextProps.deleteList) {
          indexOf = index
        }
        return item
      })
      resulted.splice(indexOf, 1)
      this.setState({ filtered: resulted })
    }
  }

  activeList = (listData) => {
    if (!listData) return;
    const { internExtern } = this.props
    const { activeValue, internExternVal } = this.state;

    if (internExtern) {
      const newList = listData.map(list => {
        if (activeValue === 0 && internExternVal === 0 && list.active && list.internal === 0) {
          return list
        } else if (activeValue === 1 && internExternVal === 1 && !list.active && list.internal === 1) {
          return list
        } else if (activeValue === 0 && internExternVal === 1 && list.active && list.internal === 1) {
          return list
        } else if (activeValue === 1 && internExternVal === 0 && !list.active && list.internal === 0) {
          return list
        } else if (activeValue === 2 && internExternVal === 0 && list.internal === 0) {
          return list
        } else if (activeValue === 2 && internExternVal === 1 && list.internal === 1) {
          return list
        } else if (activeValue === 1 && internExternVal === 2 && !list.active) {
          return list
        } else if (activeValue === 0 && internExternVal === 2 && list.active) {
          return list
        } else if (activeValue === 2 && internExternVal === 2) {
          return list
        } else
          return false
      })
      this.setState({
        filtered: newList.filter(Boolean)
      })
    }
    else {
      const newList = listData.map(list => {
        if (activeValue === 0 && list.active) {
          return list
        } else if (activeValue === 1 && !list.active) {
          return list
        } else if (activeValue === 2) {
          return list
        } else
          return false
      })
      this.setState({
        filtered: newList.filter(Boolean)
      })
    }
  }



  filterActiveList = (e) => {
    const { activeValue, internExternVal, filterField } = this.state;
    const { listData, internExtern } = this.props;
    let filteredData
    let concat
    if (filterField !== "") {
      filteredData = listData.filter((project) => {
        const listname = project.name.toLowerCase();
        let customer_name, customer_shortname
        if (project.customer_name) {
          customer_name = project.customer_name.toLowerCase();
          customer_shortname = project.customer_shortname.toLowerCase();
          concat = listname + "" + customer_name + "" + customer_shortname
        } else
          concat = listname
        const filter = filterField.toLowerCase();
        // let newList = project.name.toLowerCase().includes(filterField.toLowerCase())
        return concat.includes(filter)

      });
    } else {
      filteredData = listData
    }
    if (internExtern) {
      const newList = filteredData.map(list => {
        if (activeValue === 0 && internExternVal === 0 && list.active && list.internal === 0) {
          return list
        } else if (activeValue === 1 && internExternVal === 1 && !list.active && list.internal === 1) {
          return list
        } else if (activeValue === 0 && internExternVal === 1 && list.active && list.internal === 1) {
          return list
        } else if (activeValue === 1 && internExternVal === 0 && !list.active && list.internal === 0) {
          return list
        } else if (activeValue === 2 && internExternVal === 0 && list.internal === 0) {
          return list
        } else if (activeValue === 2 && internExternVal === 1 && list.internal === 1) {
          return list
        } else if (activeValue === 1 && internExternVal === 2 && !list.active) {
          return list
        } else if (activeValue === 0 && internExternVal === 2 && list.active) {
          return list
        } else if (activeValue === 2 && internExternVal === 2) {
          return list
        } else
          return false
      })
      this.setState({
        filtered: newList.filter(Boolean),
      })
    } else {
      const newList = filteredData.map(list => {
        if (activeValue === 0 && list.active) {
          return list
        } else if (activeValue === 1 && !list.active) {
          return list
        } else if (activeValue === 2) {
          return list
        } else {
          return false
        }
      })
      this.setState({
        filtered: newList.filter(Boolean)
      })
    }

  }


  render() {
    const { filtered, filterField, internExternVal, activeValue } = this.state
    const { listData, tittle, internExtern, getDataOfSelectedItemFunc, createNewListFunc, activeField, isRight } = this.props
    return (
      <div>
        <Card className="p-40 text-center" style={{
          padding: '20px'

        }}>
          {activeField &&
            <FormControl fullWidth variant="outlined">
              <TextField
                disabled={isEmpty(listData) ? true : false}
                variant="outlined"
                onChange={(e) => {
                  createNewListFunc()
                  this.setState({ activeValue: e.target.value }, () => {
                    this.filterActiveList(e)
                  })
                }}
                value={activeValue}
                select
              >
                <MenuItem value={0}>aktiv</MenuItem>
                <MenuItem value={1}>nicht aktiv</MenuItem>
                <MenuItem value={2}>alle</MenuItem>
              </TextField>
            </FormControl>
          }
          {internExtern &&
            <FormControl fullWidth variant="outlined">
              <TextField
                disabled={isEmpty(listData) ? true : false}
                variant="outlined"
                onChange={(e) => {
                  createNewListFunc()
                  this.setState({ internExternVal: e.target.value }, () => {
                    this.filterActiveList(e)
                  })
                }
                }
                value={internExternVal}
                select
              >
                <MenuItem value={0}>extern</MenuItem>
                <MenuItem value={1}>intern</MenuItem>
                <MenuItem value={2}>alle</MenuItem>

              </TextField>
            </FormControl>
          }
          <FormControl fullWidth variant="outlined">
            <TextField
              disabled={isEmpty(listData) ? true : false}
              label="Filter"
              variant="outlined"
              onChange={(e) =>
                this.setState({ filterField: e.target.value }, () => {
                  this.filterActiveList(e)
                })
              }
              value={filterField}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                )
              }} />
          </FormControl>
          <List dense>
            <ListItem>
              {isRight === 2 &&
                <Link onClick={() => {
                  // this.setState({ filterField: '', filtered: listData, activeValue: 2, internExternVal: 2 })
                  createNewListFunc()
                }}>
                  {tittle}
                </Link>
              }
            </ListItem>
          </List>

          <Divider />

          <div>
            {filtered &&
              <List dense>
                {filtered.map((item, index) => (
                  <ListItem key={index}>
                    <Link href="#" onClick={() => {
                      getDataOfSelectedItemFunc(item)
                    }
                    }>
                      {item.name}
                    </Link>
                  </ListItem>
                ))}
              </List>
            }
          </div>
        </Card>

      </div>
    )
  }
}
